import React, { forwardRef } from 'react';
import { TabsItem } from 'snacks-design-system';

interface componentProps {
  id: string;
  aria: { controls: string };
  onClick?: () => void;
  isSelected?: boolean;
  isDisabled?: boolean;
  children: React.ReactNode;
}

export const PIETabItem = forwardRef<any, componentProps>((props, ref) => {
  return (
    <TabsItem ref={ref} {...props}>
      {props.children}
    </TabsItem>
  );
});

PIETabItem.displayName = 'PIETabItem';
